/**
 * Public tourism reads (M7-T02 endpoints). M7-T03 uses the specialties + cards
 * for the home; M7-T04 uses the detail for the tourism profile. Read-only — the
 * only Tourism write is the enquiry (M7-T01 / M7-T05).
 */
import { apiFetch } from '../lib/api'

export type TourismSpecialty = {
  slug: string
  name: string
  hospital_count: number
}

export type TourismHospitalCard = {
  slug: string
  name: string
  city: string
  region_code: string
  accreditations: string[]
  languages: string[]
  specialties: string[]
}

export type TourismHospitalDetail = {
  slug: string
  name: string
  city: string
  address: string
  description_tourism: string | null
  accreditations: string[]
  languages: string[]
  international_desk_phone: string | null
  whatsapp: string | null
  photo_urls: string[]
  specialties: string[]
}

export function tourismSpecialtiesKey() {
  return ['tourism-specialties'] as const
}

export function tourismHospitalsKey(specialty: string | null) {
  return ['tourism-hospitals', specialty] as const
}

export function tourismHospitalKey(slug: string) {
  return ['tourism-hospital', slug] as const
}

/** GET /api/v1/tourism/specialties — the 15 specialties + hospital counts. */
export async function fetchTourismSpecialties(
  signal?: AbortSignal,
): Promise<TourismSpecialty[]> {
  const opts = signal ? { signal } : {}
  const body = await apiFetch<{ data: TourismSpecialty[] }>(
    '/api/v1/tourism/specialties',
    opts,
  )
  return body.data
}

/** GET /api/v1/tourism/hospitals?specialty= — tourism hospital cards. */
export async function fetchTourismHospitals(
  specialty: string | null,
  signal?: AbortSignal,
): Promise<TourismHospitalCard[]> {
  const qs = specialty ? `?specialty=${encodeURIComponent(specialty)}` : ''
  const opts = signal ? { signal } : {}
  const body = await apiFetch<{ data: TourismHospitalCard[] }>(
    `/api/v1/tourism/hospitals${qs}`,
    opts,
  )
  return body.data
}

/** GET /api/v1/tourism/hospitals/{slug} — tourism profile detail. */
export async function fetchTourismHospital(
  slug: string,
  signal?: AbortSignal,
): Promise<TourismHospitalDetail> {
  const opts = signal ? { signal } : {}
  const body = await apiFetch<{ data: TourismHospitalDetail }>(
    `/api/v1/tourism/hospitals/${slug}`,
    opts,
  )
  return body.data
}
